import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { CompanyService } from 'src/app/admin/services/company.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { ErrorComponent } from 'src/app/trip-calculator/components/error/error.component';
import { CompanySize } from 'src/app/user/model/user';

interface CompanyInfo {
  vatNumber?: string;
  size?: CompanySize;
}

@Component({
  selector: 'app-update-company-info',
  imports: [
    DialogModule,
    ButtonModule,
    TranslocoPipe,
    ReactiveFormsModule,
    ErrorComponent,
    InputTextModule,
    SelectModule,
  ],
  templateUrl: './update-company-info.component.html',
})
export class UpdateCompanyInfoComponent implements OnInit {
  @Input() visible = false;
  @Output() companyUpdated = new EventEmitter();

  fb = inject(FormBuilder);
  transloco = inject(TranslocoService);
  currentUserService = inject(CurrentUserService);
  companyService = inject(CompanyService);
  notificationService = inject(NotificationService);

  companyInfo?: CompanyInfo;
  companyInfoForm = this.fb.nonNullable.group({
    vatNumber: ['', Validators.required],
    size: ['', Validators.required],
  });
  sizeOptions: { value: string; label: string }[] = [];

  loading = false;

  constructor() {
    effect(() => {
      if (!this.companyInfo) {
        this.companyInfo = this.currentUserService.currentUser()?.company;
        this.populateForm();
      }
    });
  }

  async ngOnInit() {
    this.initializeSizeOptions();
  }

  initializeSizeOptions() {
    const rawOptions = Object.values(CompanySize);
    for (const option of rawOptions) {
      const label = this.transloco.translate(`companySize.${option}`);
      const value = option;
      this.sizeOptions.push({ label, value });
    }
  }

  populateForm() {
    console.log('wtf?', this.companyInfo);
    if (this.companyInfo) {
      this.companyInfoForm.patchValue(this.companyInfo);
    }
  }

  submit() {
    if (this.companyInfoForm.valid) {
      this.loading = true;
      const data = this.companyInfoForm.getRawValue();
      this.companyInfo = {
        vatNumber: data.vatNumber,
        size: data.size as CompanySize,
      };
      const companyId = this.currentUserService.currentUser()?.company?.id;
      this.companyService
        .updateCompany(companyId!, this.companyInfo)
        .subscribe({
          next: () => {
            this.companyUpdated.emit(true);
            this.loading = false;
          },
          error: (response) => {
            console.error(response);
            this.loading = false;
            this.notificationService.error(
              this.transloco.translate(
                'accountMenu.billingInformation.updateBillingError',
              ),
            );
          },
        });
    }
  }
}
